export default {
  'component.salespreparation.title': 'Salgsforberedelser',
  'component.salespreparation.bookinspection': 'Book befaring',
  'component.salespreparation.energylabeling': 'Energimerking',
  'component.salespreparation.photos': 'Boligfoto',
  'component.salespreparation.rate': 'Takst',
  'component.salespreparation.styling': 'Styling',
  'component.salespreparation.sellerinformation': 'Selgers intervju',
};
